import { v4 } from 'uuid';

import { CreditResponsibility, Currency, Loan, LoanType } from 'src/api/zrm';
import { SharedNorwayLoan, SharedNorwayLoanDetails } from 'src/types/SharedForm/loans/SharedNorwayLoansForm';


const mapLoan = (loan: SharedNorwayLoan, type: LoanType): Loan => ({
  loan_type: type,
  amount: loan.totalAmount,
  rate: +(loan.rate / 100).toFixed(4),
  monthly_payment: loan.monthlyPayment,
  currency: Currency.NOK,
  loan_id: v4(),
  bank_id: 255, // Hardcoded for now to `Other` bank
  responsibility: loan.multipleBorrowers ? CreditResponsibility.SHARED : CreditResponsibility.MAIN_APPLICANT as any,
});

const mapLoans = (loans: SharedNorwayLoanDetails[]): Loan[] => {
  const filteredLoans = loans.filter(loan => loan.hasLoan);

  const reduced = filteredLoans.reduce((acc, filteredLoan) => [...acc, ...filteredLoan.loans.map((fl) => mapLoan(fl, filteredLoan.loanType))], []);

  return reduced;
};

export default mapLoans;
